import { Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import ExchangeDetails from './ExchangeDetails'
import SupportingDoc from 'views/Accounts/Workshop/Maintenance/ManageInvoice/SupportingDoc'
import Invoices from 'views/Accounts/Workshop/Maintenance/ManageInvoice/Invoices'
import PartSalesServices from 'lib/services/api/commercial/parts'
import { getOrganisationId } from 'lib/utils/common_utils'

export default function FinanceDetails(props) {

    const { coreId,
        coreDetails,
        getCoreTableDetails,
        isRefreshTable,
        isInvoiceOpen } = props
    const [files, setFiles] = useState([])

    // /core_supporting_documents
    const getFilesDetails = async () => {
        const params = { core_parent_id: coreId };
        const params1 = { organisation_id: getOrganisationId(), sales_order_id: coreDetails?.sales_order_id };

        try {
            const [response, response1] = await Promise.all([
                PartSalesServices.getCoreExchangeFilesPhp(params),
                PartSalesServices.getFinanceFiles(params1),
            ]);

            const mergedFiles = {
                ...(response?.data || {}),
                ...(response1 || {}),
            };

            setFiles(mergedFiles);
        } catch (error) {
            console.error("Error fetching file details:", error);
        }
    };

    useEffect(() => {
        getFilesDetails()
    }, [])


    return (
        <div>
            <Typography color="primary" gutterBottom={"10px"}>
                Finance
            </Typography>

            <Grid container xs={12} spacing={2}>

                <Grid item xs={4}>
                    <ExchangeDetails
                        coreId={coreId}
                        isRefreshTable={isRefreshTable} />
                </Grid>
                <Grid item xs={4}>
                    <SupportingDoc
                        financeOrderList={files}
                        tabName={"Core"}
                        salesID={coreDetails?.sales_order_id}
                        type={"SalesOrder"}
                        id={coreDetails?.sales_order_id} /></Grid>

                <Grid item xs={4}>

                    <Invoices
                        financeOrderList={coreDetails}
                        orderType={""}
                        getFinanceWorkshopOrderList={getCoreTableDetails}
                        currentSelection={{ id: coreId }}
                        type={"SalesOrderCore"}
                        height={"315px"}
                        permission={props?.permission}
                        isInvoiceOpen={isInvoiceOpen}
                        {...props} />
                </Grid>


            </Grid>




        </div>
    )
}

